const PIXEL_ID = '1237805027999662'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Initialize fbq
  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Init pixel and fire PageView
  f.fbq('init', PIXEL_ID)
  f.fbq('track', 'PageView')

  initialized = true
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', eventName, params)
  }
}
